import cpSite from './cpSite'

/**
 * theme123-block-quick-tabs
 * Работа табов на главной странице
 */
const quicktabs = {
  state: {
    isActive: false
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: quicktabs')
    }
    // Получаем все табы и контентные блоки
    const tabs = document.querySelectorAll('.qt_tab')
    // const tabContents = document.querySelectorAll('.quicktabs_tabpage')

    // Функция для обработки клика на таб
    function onTabClick (event) {
      event.preventDefault() // Отменяем стандартное поведение ссылки

      // Удаляем класс active и спрятанного состояния с предыдущего активного таба и контента
      document.querySelectorAll('.qt_tab.active').forEach((el) => el.parentElement.classList.remove('active'))
      document.querySelectorAll('.qt_tab.active').forEach((el) => el.classList.remove('active'))
      document.querySelectorAll('.quicktabs_tabpage:not(.quicktabs-hide)').forEach((el) => el.classList.add('quicktabs-hide'))

      // Добавляем класс active для текущего таба и отображаем соответствующий контентный блок
      const currentTab = event.target
      currentTab.classList.add('active')
      currentTab.parentElement.classList.add('active')
      const contentId = currentTab.id.replace('quicktabs-tab', 'quicktabs_tabpage').replaceAll('-', '_')
      document.getElementById(contentId).classList.remove('quicktabs-hide')
    }

    // Вешаем обработчик события клика на каждый таб
    tabs.forEach(tab => tab.addEventListener('click', onTabClick))

    // Запись об активации скрипта
    this.state.isActive = true
  }
}

export default quicktabs
